import { useHistory, useParams } from 'react-router-dom'
import useEntity from '../../hooks/useEntity'
import Loading from '../../components/Loading'
import * as React from 'react'
import LegalPersonForm from '../../components/Form/Party/LegalPersonForm'
import { LegalPersonMutationDto } from '../../config/partyConfig'
import useAxios from '../../hooks/useAxios'
import { getPartyOverviewUrl } from './AddNaturalPerson'

export default function EditLegalPerson() {
    const axios = useAxios()
    const history = useHistory()
    const { fileId, id } = useParams<{ fileId?: string; id?: string }>()
    const [entity] = useEntity<LegalPersonMutationDto>(id => ({ url: `/party/${id}` }), id)

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <LegalPersonForm
            formikProps={{
                initialValues: {
                    addressCountry: 'NL',
                    poBoxAddressCountry: 'NL',
                    ...entity.data,
                },
            }}
            onSubmit={(party: LegalPersonMutationDto) => axios.put<string>(`/party/legal/${id}`, party)}
            goBack={() => history.replace(getPartyOverviewUrl(fileId))}
        />
    )
}
